import './Footer.scss';
import { EMAIL, TEL } from '../../core/constants';
import TelLink from '../TelLink';
import { useTranslation } from 'react-i18next';
import { PublicRoutesEnum } from '../../core/enums';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <div className='Footer'>
      <div className='container'>
        <div className='row'>
          <div className='d-flex flex-column flex-lg-row justify-content-between'>
            <div className='d-flex flex-column flex-lg-row align-items-center order-lg-2'>
              <TelLink
                tel={TEL}
                className='mb-3 mb-lg-0 me-lg-4 Footer__text'
              />
              <a
                href={`mailto:${EMAIL}`}
                className='mb-3 mb-lg-0 ms-lg-2 Footer__text'
              >
                {EMAIL}
              </a>
            </div>
            <div className='d-flex flex-column flex-lg-row align-items-center'>
              <a
                href={PublicRoutesEnum.TermsOfService}
                className='text-nowrap mb-3 mb-lg-0 pb-lg-0 ms-lg-2 order-lg-2 Footer__text'
                target='_blank'
                rel='noopener noreferrer'
              >
                {t('Terms of Service')}
              </a>
              <a
                href={PublicRoutesEnum.DataProcessingAgreement}
                className='text-nowrap mb-3 pb-3 mb-lg-0 pb-lg-0 ms-lg-2 order-lg-2 Footer__text'
                target='_blank'
                rel='noopener noreferrer'
              >
                {t('Data Processing Agreement')}
              </a>
              <span className='me-lg-4 Footer__text'>
                © 2022 by countX GmbH
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
